/* eslint-disable import/no-cycle */
import { createSlice } from '@reduxjs/toolkit';
import { getUserThunk } from './userSlice';
import { postAuthRefresh } from '../api';
import { Logger } from '../utils';
import { fetchExperiments } from './experimentsSlice';

const authTokenSlice = createSlice({
  name: 'authToken',
  initialState: {
    isLoading: false,
    token: null,
  },
  reducers: {
    setAuthToken: (state, action) => {
      state.token = action?.payload || null;
      state.isLoading = false;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    removeAuthToken: (state) => {
      state.token = null;
      state.isLoading = false;
    },
  },
});

const { setAuthToken, setIsLoading, removeAuthToken } = authTokenSlice.actions;

const fetchRefreshToken = (appName) => (dispatch) => {
  dispatch(setIsLoading(true));
  return postAuthRefresh().then(async (response) => {
    if (response?.token) {
      dispatch(setAuthToken(response.token));
      const user = await dispatch(getUserThunk());
      dispatch(fetchExperiments(user?.id));
      return true;
    }
    dispatch(fetchExperiments());
    return false;
  }).catch((error) => {
    if (error) {
      Logger.error(`[${appName}] Error fetching refresh token: ${error}`);
    }
    dispatch(fetchExperiments());
    dispatch(setIsLoading(false));
    return false;
  });
};

const selectIsAuthenticated = (state) => !!state.authToken?.token;

export {
  fetchRefreshToken,
  selectIsAuthenticated,
  setAuthToken,
  removeAuthToken,
};
export default authTokenSlice.reducer;
